import { OpacityBox } from 'src/components/UI/OpacityBox';
import { UIButton } from 'src/components/UI/UIButton';
import { Icon } from '@iconify/react';

const ECOSYSTEM = [
  {
    icon: 'fa6-solid:chart-simple',
    title: 'Marketing Support',
    description: 'Gain visibility for your innovations.',
  },
  {
    icon: 'fa6-solid:wallet',
    title: 'Funding Opportunities',
    description: 'Access financial support for your AI products.',
  },
  {
    icon: 'fa6-solid:gear',
    title: 'Technical Assistance',
    description: 'Collaborate and receive expert support.',
  },
];

export const AgentsBanner = () => {
  const handleApplyNowClick = () => {
    //   TODO: add func
  };

  return (
    <div className="container mx-auto flex flex-col justify-end">
      <div className="relative mb-20">
        <div className="flex w-full flex-col items-center">
          <span className="mb-3 text-sm font-bold opacity-40">External AI Agents</span>
          <h2 className="mb-4 text-5xl font-bold">Join Our AI Ecosystem!</h2>
          <p className="mb-9 text-lg">
            Are you an AI developer looking to showcase your cutting-edge models?
          </p>
          <ul className="mb-9 flex flex-col gap-2 sm:flex-row">
            {ECOSYSTEM.map((el) => (
              <li key={el.title}>
                <OpacityBox className="flex items-center gap-2 rounded-[12px] bg-opacity-20 p-4 backdrop-blur-3xl">
                  <OpacityBox className="rounded-[12px] bg-opacity-10 p-3.5 backdrop-blur-xl">
                    <Icon icon={el.icon} className="size-5" />
                  </OpacityBox>
                  <div className="flex flex-col gap-1 text-xs font-bold">
                    <span>{el.title}</span>
                    <span className="opacity-50">{el.description}</span>
                  </div>
                </OpacityBox>
              </li>
            ))}
          </ul>
          <UIButton
            buttonColor="blue"
            className="w-[204px]"
            size="xl"
            onClick={handleApplyNowClick}
          >
            Apply Now
            <Icon icon="fa6-solid:circle-arrow-right" className="ml-1" />
          </UIButton>
        </div>
        <div
          className="pointer-events-none fixed bottom-0 left-0 -z-10 my-10 h-[380px] w-screen overflow-hidden bg-[length:auto_100%] bg-right bg-no-repeat p-10"
          style={{ backgroundImage: "url('/images/ai-marketplace/bottom-banner.png')" }}
        />
      </div>
    </div>
  );
};
